import type { ValueEvent } from '@adornis/base/utilTypes';
import '@adornis/chemistry/elements/components/stack/x-stack.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { stateful, useState } from '@adornis/functional-lit/stateful';
import { html } from 'lit';
import { createDraft } from '../api/createDraft';
import { Draft } from '../db/Draft';

export const CreateDraft = stateful(
  ({
    draftClassName,
    reference,
    draftTemplate,
    onAfterCreateCallback,
  }: {
    draftClassName: string;
    reference: {
      _class: string;
      _id: string;
    };
    draftTemplate?: Draft;
    onAfterCreateCallback: (draft: Draft) => void;
  }) => {
    const [draftOptions, setDraftOptions] = useState<undefined | Pick<Draft, 'name' | 'description'>>(
      draftTemplate ? { name: draftTemplate.name, description: draftTemplate.description } : undefined,
    );

    if (!draftOptions)
      return html`
        <x-button
          @click=${async () => {
            setDraftOptions({ name: '', description: '' });
          }}
        >
          Neuen Entwurf anlegen
        </x-button>
      `;
    return html`
      <d-flex space="md">
        <d-input
          placeholder="Name (optional)"
          .value=${draftOptions.name}
          @value-changed=${(e: ValueEvent<string>) => {
            draftOptions.name = e.detail.value;
          }}
        ></d-input>
        <d-input
          placeholder="Beschreibung (optional)"
          .value=${draftOptions.description}
          @value-changed=${(e: ValueEvent<string>) => {
            draftOptions.description = e.detail.value;
          }}
        ></d-input>
        <d-flex horizontal crossaxis-center space-between space="md" wrap>
          <x-button
            mode="outline"
            @click=${async () => {
              setDraftOptions(undefined);
            }}
          >
            Abbrechen
          </x-button>
          <x-button
            @click=${async () => {
              const draft = await createDraft(
                draftClassName,
                reference._class,
                reference._id,
                new Draft({
                  ...draftTemplate?.toObject(),
                  name: draftOptions.name,
                  description: draftOptions.description,
                }),
              )({ _id: 1 });

              onAfterCreateCallback(draft);
              XSnackbar.show('Entwurf angelegt');
              setDraftOptions(undefined);
            }}
          >
            Anlegen
          </x-button>
        </d-flex>
      </d-flex>
    `;
  },
);
